export default {
  "navbar": {
    "logo": {
      "link": "#"
    },
    "list": [
      {
        "name": "技术指南",
        "link": "/#guide",
        "是否显示": true
      },
      {
        "name": "最新动态",
        "link": "/#message",
        "是否显示": true
      },
      {
        "name": "精彩活动",
        "link": "/#activity",
        "是否显示": true
      },
      {
        "name": "白皮书",
        "link": "/#whitePaper",
        "是否显示": true
      },
      {
        "name": "客户案例",
        "link": "/#case",
        "是否显示": true
      },
      {
        "name": "PSO专业服务",
        "link": "/#pso",
        "是否显示": true
      }
    ]
  },
  "scroll": {
    "list": [
      {
        "title": "安全",
        "text": "世界一流的安全机制帮助您降低风险"
      },
      {
        "title": "多云端",
        "text": "混合云和多云端为您带来更多选择"
      },
      {
        "title": "全托管式运营",
        "text": "无服务器产品让一切更简单"
      },
      {
        "title": "嵌入式 AI 和机器学习",
        "text": "通过 AI 和机器学习推动创新"
      },
      {
        "title": "GOOGLE 一站式服务",
        "text": "借助全套云服务实现现代化"
      },
      {
        "title": "集成开源软件",
        "text": "使用托管式开源软件进行开发"
      },
      {
        "title": "世界一流的基础架构",
        "text": "依赖于 Google 的全球网络"
      }
    ]
  },
  "guide": {
    "title": {
      "mainTitle": "独家技术指南",
      "subTitle": "Google Cloud 技术专家撰写的独家技术文档为你指点迷津"
    },
    "list": [
      {
        "title": "如何自定义 GCE 主机名",
        "link": "https://www.infoq.cn/zones/google/cloud/article/wkX6GKfwO62hCp75t7ws"
      },
      {
        "title": "GKE创建Pod采用Regional Disk的实现",
        "link": "https://www.infoq.cn/zones/google/cloud/article/L2VCBUzTS6DN9uTfML23"
      },
      {
        "title": "使用数据流转换和导出 CDN 日志",
        "link": "https://www.infoq.cn/zones/google/cloud/article/W6wbBCONHCfGiLgRU5Wz"
      },
      {
        "title": "Google Cloud VPC Peering 广播动态路由",
        "link": "https://www.infoq.cn/zones/google/cloud/article/diC7XBvhhR8lPTOgWhlX"
      },
      {
        "title": "从AWS EC2迁移到GCP",
        "link": "https://www.infoq.cn/zones/google/cloud/article/jpSrNUhGvxgjo3Y2x1W0"
      },
      {
        "title": "使用 GKE Connect 管理微软 AKS 服务",
        "link": "https://www.infoq.cn/zones/google/cloud/article/XpQVcbiIZPFZ08wyxGwD"
      },
      {
        "title": "通过 BigQuery 查询 Http 负载均衡流量信息的实现方法",
        "link": "https://www.infoq.cn/zones/google/cloud/article/zStoIm8FGfuUA7ec7wjY"
      },
      {
        "title": "GKE 多种 Ingress 的实现",
        "link": "https://www.infoq.cn/zones/google/cloud/article/FwOkvi6zuxDSsiALsaHz"
      },
      {
        "title": "使用 Nginx 实例组实现 CDN 外部源站",
        "link": "https://www.infoq.cn/zones/google/cloud/article/GTyKaUpiz7sVbU36U9PY"
      },
      {
        "title": "使用 GCP 的 IAP 功能实现 VM 无公网 IP 的 SSH 登陆 ",
        "link": "https://www.infoq.cn/zones/google/cloud/article/omcQHjLCFFsFwJti2OOq"
      },
      {
        "title": "Google Cloud 导入标准 CentOS 镜像 ",
        "link": "https://www.infoq.cn/zones/google/cloud/article/B5DBf7kOVhshFpPKCTUN"
      },
      {
        "title": "Google Cloud IAM 中添加自定义域名",
        "link": "https://www.infoq.cn/zones/google/cloud/article/wglK2TS7V1kD0P9lChjS"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=0",
      "text": "查看更多"
    }
  },
  "questionnaire": {
    "title": "即刻参与 Google Cloud 专区调查",
    "button": {
      "link": "https://jinshuju.net/f/lm2Zps",
      "text": "立即参与"
    }
  },
  "message": {
    "title": {
      "mainTitle": "最新动态",
      "subTitle": "这里包含你想知道的 Google Cloud 技术趋势与最新解读"
    },
    "list": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/3CU8SI0YO9Hm2t3Z7sco",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/84/0f/84ad239e17b87ea08b88a60741108e0f.png",
        "origin": "混合云",
        "title": "降低应用程序现代化门槛：Anthos 为混合云环境带来托管服务网格与无服务器解决方案",
        "text": "数十年来，各类组织机构一直在自有数据中心之内构建并运行各类应用程序。不过面对近几年如火如荼的云计算革命，在云端部署及运行应用程序也开始成为一类重要运营选项。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/sQGW9Ub1HeIz7ycVfF45",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-big.ca0d0462.jpg",
        "origin": "数据分析",
        "title": "BigQuery数据转换简化大法：让机器学习更轻松高效",
        "text": "我们宣布在BigQuery ML中添加一系列新功能，帮助用户通过简单的SQL函数实现数据的预处理与转换。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/MYAgDPldb53O4zmhjhei",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-2.6e85a024.jpg",
        "origin": "行业",
        "title": "Gartner发布最新魔力象限报告，Google Cloud跻身运营数据库管理系统领导者",
        "text": "Gartner在其2019年《运营数据库管理系统（OPDBMS）魔力象限》报告中，将Google Cloud列入领导者区间。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/SHR6KFboNRRlN3GidGgB",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-apex.fae19c16.jpg",
        "origin": "游戏",
        "title": "Google Cloud 助力 Multiplay 创下 Apex Legends 首发纪录",
        "text": "凭借着一流的云服务器编排框架以及24/7/365全天候专业服务团队，Multiplay得以顺利支持游戏极速飙升的人气。这套编排框架采用Google Cloud。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/rVSrxPwl3EQv3yklEBxT",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/7e/8a/7ea3af94afa90433d93d54c194524f8a.png",
        "origin": "AI和机器学习",
        "title": "AI 发展迎来下一轮突破，无数虚拟世界蕴藏其中",
        "text": "2012年，ImageNet训练数据集的正式亮相在人工智能开发领域掀起一波巨浪。在实际应用角度来看，此次浪潮带来的最引人注目的成功案例，无疑是AI视觉模型。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/SkAsEJiyKD4UuOewXDrv",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/9c/39/9c51adeffb00e2700691c8dd432f8839.png",
        "origin": "无服务器",
        "title": "托管 Knative 服务 Cloud Run 正式迎来通用版本",
        "text": "对于企业而言，无论是在内部运行Kubernetes环境，还是选择全托管型无服务器计算平台，我们的目标都始终明确：为开发人员赋能。今天，我们宣布谷歌云正式发布Cloud Run通用版本。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/jE7usKLrwoEYBYYaHYC3",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/95/43/9555ae7298db5e29836d7e0ee6511443.png",
        "origin": "AI和机器学习",
        "title": "将 Google AutoML 带给 Kaggle 上的350万数据科学家",
        "text": "最近，Kaggle项目的发展迎来重大里程碑——利用这套平台学习并运用机器学习技术的用户已经超过350万。"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=1",
      "text": "查看更多"
    }
  },
  "activity": [
    {
      "imageList": "https://static001.geekbang.org/static/business/img/activity.1598457d.png",
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "ArchSummit 技术专场—企业出海：云，数据，智能",
          "time": "2019年12月6日 13:30-17:30",
          "address": "北京 · 国际会议中心 201CD会议室",
          "text": "由极客邦科技主办的 Arch Summit 全球架构师峰会北京站已落幕，来自 Google Cloud 的 4 位技术专家，从基础设施服务、Kubernetes、数据洞察力、AI 和机器学习几大方面分享了其技术实践。"
        }
      },
      "button": {
        "link": "https://www.infoq.cn/article/3VykShAqhXb6VxQVPcB3",
        "text": "活动回顾"
      }
    },
    {
      "imageList": require('../assets/img/google-img/activity5.png'),
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "数据驱动决策，智能助力远航",
          "time": "2020年2月27日 15：00-16：00",
          "address": "线上分享",
          "text": "Google Cloud 作为云计算和大数据的领导者，结合十多年的经验，开发了诸多跨时代的产品，为全球的企业，提供了云端服务、数据分析和商业智能等高效的解决方案。作为企业管理者、业务负责人，该如何借助Google Cloud强大的云端服务，有效利用这些数据？"
        }
      },
      "button": {
        "link": "http://cms.hftty.cn/live/detail/id/133.html",
        "text": "查看活动"
      }
    },
    {
      "imageList": require('../assets/img/google-img/activity4.png'),
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "Cloud OnAir 线上课堂",
          "time": "2020年",
          "address": "线上分享",
          "text": "Cloud OnAir 是由 Google Cloud 团队发起的线上会议，定期邀请行业专家、技术大咖、客户及合作伙伴，对 Google Cloud 的产品、技术及实际使用经验，进行分享和讲解。关注 Cloud OnAir，学习如何高效上手 Google Cloud！"
        }
      },
      "button": {
        "link": "http://cms.hftty.cn/",
        "text": "更多课程回看"
      }
    },
    {
      "imageList": "https://static001.geekbang.org/static/business/img/activity3.d7d896d4.png",
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "Google Cloud数字峰会——助力企业扬帆出海",
          "time": "2020年1月9日，14:00-17:15",
          "address": "线上分享",
          "text": "Google Cloud基础架构如何？Google Cloud承载了 Kubernetes、TensorFlow等享誉全球的开源技术，在容器化、AI和机器学习有哪些优势？Google Cloud 如何通过消费者分析和数据洞察为企业提供针对用户更精准的决策？"
        }
      },
      "button": {
        "link": "http://cms.hftty.cn/Live/detail/id/108.html?traincode=infoq",
        "text": "查看活动"
      }
    }
  ],
  "whitePaper": {
    "title": {
      "mainTitle": "<span style=\"font-family: google-word\"> Google Cloud </span>白皮书",
      "subTitle": "深入介绍 GCP 与实际应用"
    },
    "list": [
      {
        "link": "https://jinshuju.net/f/n92l7b",
        "downloadLink": "https://jinshuju.net/f/n92l7b",
        "title": "Google 安全性白皮书",
        "text": "本份白皮书概述了 Google 在 Google Cloud 公有云产品与服务组合当中使用的安全性与合规性方法。"
      },
      {
        "link": "https://jinshuju.net/f/IvfuPR",
        "downloadLink": "https://jinshuju.net/f/IvfuPR",
        "title": "Kubernetes：你的混合云战略",
        "text": "本白皮书主要探讨Kubernetes如何为大家的混合云发展战略提供答案，以及如何建立起一套用于简化部署、管理以及运营问题的整体性解决方案。"
      },
      {
        "link": "https://jinshuju.net/f/XjcgRx",
        "downloadLink": "https://jinshuju.net/f/XjcgRx",
        "title": "将工作负载迁移至公有云环境：基础指南与事项清单",
        "text": "本份白皮书整理出相关提示，希望帮助 IT 部门分步完成整个迁移流程中的四大基本环节：评估、规划、迁移以及优化。"
      },
      {
        "link": "https://jinshuju.net/f/4pexK5",
        "downloadLink": "https://jinshuju.net/f/4pexK5",
        "title": "Google BigQuery深度剖析报告",
        "text": "本白皮书旨在介绍Google BigQuery，这是一项全托管云服务，为用户提供面向海量数据的交互式查询功能。"
      },
      {
        "link": "https://jinshuju.net/f/g1z7bn",
        "downloadLink": "https://jinshuju.net/f/g1z7bn",
        "title": "关于 Google Cloud Anthos 的五个常见问题",
        "text": "在 Kubernetes 以及其他多种开源技术的支持之下，Anthos 也成为目前市面上唯一一套基于软件的混合平台。"
      },
      {
        "link": "https://jinshuju.net/f/9tc8V5",
        "downloadLink": "https://jinshuju.net/f/9tc8V5",
        "title": "云端数据治理原则与最佳实践",
        "text": "如果大家有意将数据迁移至云端，本份白皮书希望为您提供在此期间与数据治理相关的指导意见与最佳实践。"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=2",
      "text": "查看更多"
    }
  },
  "case": {
    "title": {
      "mainTitle": "客户和案例研究",
      "subTitle": "借力云端技术，携手合作伙伴"
    },
    "listTop": [
      {
        "imgSrc": "https://static001.geekbang.org/resource/image/e8/df/e817a942e3008e503c9ddd3ba231c2df.png",
        "videoSrc": "https://media001.geekbang.org/9938a7cf24754e29bc2a741e378bb679/63903459e242493d96ad491db95a5a0c-bbd0fa0398be9cdf06950bb5c176279a-hd.mp4",
        "origin": "社交网络",
        "title": "Twitter 拥抱谷歌云"
      },
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/video2.5a887292.png",
        "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/38067503-16f846d4a21-0000-0000-01d-dbacd.mp4",
        "origin": "游戏",
        "title": "Google Cloud 助力 Pocket Gems"
      },
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/video1.b67ae10e.png",
        "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/47c9f83d-16f843c6415-0000-0000-01d-dbacd.mp4",
        "origin": "零售",
        "title": "认识ShopBot：eBay的新AI购物助手"
      },
      {
        "imgSrc": "https://static001.geekbang.org/resource/image/9e/03/9e2cb5140592f00eeda4f953619c3703.png",
        "videoSrc": "https://media001.geekbang.org/f3f8f4ec2d114d77a461de80c83c4e9b/6863d76d76584627be8d55a6da8bd5b2-46b2ca75cac19ee9ae3f79a251a59c06-hd.mp4",
        "origin": "零售",
        "title": "Google Cloud 帮助 DSW 实时吸引超过2千8百万的鞋迷"
      },
      {
        "imgSrc": "https://static001.geekbang.org/resource/image/de/cb/de3457808b0c2804ca47d51e92d434cb.png",
        "videoSrc": "https://media001.geekbang.org/5b10e986933b47c7a3dd75607edd7b61/dea62b471db141d4a4205637bc4d6f56-4921ee19c6a310ff96aaf104fff80302-hd.mp4",
        "origin": "游戏",
        "title": "在 Google Cloud Platform 上构建游戏"
      }
    ],
    "listBottom": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/GGo4kPsdGDIPaS5PRgPv",
        "origin": "游戏",
        "title": "绿洲游戏：在高性能云平台上为游戏提供动力",
        "text": "绿洲游戏成立于2011年，是一家总部位于中国北京的数字娱乐发行公司，GCP通过合规、可靠和高性能的云平台赢得绿洲游戏的信赖。",
        "imgSrc": "https://static001.infoq.cn/resource/image/0d/bf/0dc46df391020abd133820a026cf90bf.jpeg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/hOKLtmS7kLWWeHXH1pbE",
        "origin": "科技",
        "title": "Castbox：使用Google Cloud Platform向用户传达声音",
        "text": "在Google Cloud Platform与Firebase的有力支持之下，Castbox得以运行起高度可扩展的语音音频内容平台，同时提供音频内搜索与精选播客推荐等一系列智能功能。",
        "imgSrc": "https://static001.geekbang.org/static/business/img/anli-cast.f70c913c.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/IG8q3eilZlN5rHEVUOow",
        "origin": "电信、媒体和娱乐",
        "title": "一加：通过 Google Cloud 的 AI 模型提供准确的用户反馈分析",
        "text": "一加（OnePlus）在 Cloud AutoML 上训练机器学习模型，以分析用户反馈，无需编写代码。",
        "imgSrc": "https://static001.geekbang.org/resource/image/69/3f/698573b635f1aea0c0b8da7bba58d73f.jpg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/aaBaSCcKv1Brl31a70yj",
        "origin": "媒体和娱乐",
        "title": "ELEX：支持数十万个并发聊天用户",
        "text": "在 Google Compute Engine与 Google Cloud Translation API的双重助力之下，《列王的纷争》在线聊天服务的基础设施成本降低了20%。",
        "imgSrc": "https://static001.infoq.cn/resource/image/8c/cc/8c95644627c6e4884cb0b621ff4186cc.png"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=3",
      "text": "查看更多"
    }
  },
  "pso": {
    "title": {
      "mainTitle": "PSO 专业服务与最佳实践",
      "subTitle": "帮助我们的客户和合作伙伴充分利用 Google Cloud 产品"
    },
    "content": [
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/pso1.e7e6fcca.png",
        "title": "Google Cloud 专业服务团队 (PSO) ",
        "desc": "Google专业团队协助客户解决业务上的问题和挑战，根据经过验证的方法和过去成功的实践经验來推荐最佳解决方案。",
        "link": "https://static001.infoq.cn/resource/ebook/70/66/706e1f8cdb7a900d11f30ebbf90ec166.pdf",
        "moreDesc": "查看详情"
      },
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/pso2.bf03c71e.png",
        "title": "Google Cloud 学习培训产品",
        "desc": "如果您可以轻松地强化您的团队，在一个充满活力的云端世界中茁壮成长又会怎样呢?",
        "link": "https://static001.infoq.cn/resource/ebook/a5/6e/a5e6983eea8dd387d9a06565f5cd5b6e.pdf",
        "moreDesc": "查看详情"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=4",
      "text": "查看更多"
    }
  },
  "partner": {
    "title": {
      "mainTitle": "合作伙伴",
      "subTitle": "借力于 Google Cloud 的全球云服务专家生态系统"
    },
    "partners": [
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png"
    ]
  },
  "footer": {
    "sign": "Google Cloud",
    "title": "关于<span style=\"font-family: google-word\"> Google Cloud </span>",
    "text": "在提供安全、开放、智能的变革性企业级云平台方面，Google Cloud 是公认的全球领导者。我们的技术依托 Google 专用网络构建而成，是近 20 年来在安全、网络架构、协作、人工智能和开源软件方面不懈创新的产物。我们在 Google Cloud Platform 和 G Suite 中提供了一套设计简洁的工具和无可比拟的技术，帮助客户有效地融合人力、洞见和创意。来自 150 多个国家/地区的客户依靠 Google Cloud 来实现计算环境现代化，以满足当今数字世界的需求。"
  }
}
